import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { P12 } from '../../Typography';
import { StyledSlider, StyledThresholdWrapper } from './ThresholdSlider.styled';

export interface ThresholdSliderProps {
  thresholdAngle: number;
  onThresholdChange: (e: Event, value: number | number[]) => void;
}

export const ThresholdSlider: React.FunctionComponent<ThresholdSliderProps> = ({
  thresholdAngle,
  onThresholdChange,
}) => {
  const { t } = useTranslation();

  return (
    <StyledThresholdWrapper>
      <div>
        <StyledSlider defaultValue={50} min={0} max={180} value={thresholdAngle} onChange={onThresholdChange} />
        <p>{thresholdAngle}</p>
      </div>
      <P12 $textAlign="center">{t('uiLabel.threshold')}</P12>
    </StyledThresholdWrapper>
  );
};
